// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'underscore';

const STYLE = { top: 0, bottom: 0, left: 0, right: 0 };

const CLASSES = cx(
  'full-height full-width',
  'display-flex flex-direction-column align-items-center',
  'position-fixed'
);

export default class FixedPage extends Component {
  static propTypes = {
    onClick: PropTypes.func,
  };

  shouldComponentUpdate(nextProps) {
    return !_.isEqual(_.omit(this.props, 'children'), _.omit(nextProps, 'children'));
  }

  render() {
    const { children, className, style, onClick } = this.props;

    return (
      <div name="fixed-page" onClick={onClick} className={cx(CLASSES, className)} style={{ ...STYLE, ...style }}>
        {children}
      </div>
    );
  }
}